module.exports = __webpack_public_path__ + "img/hadiah-100rb.e7395dd1.png";